import { CallAPI } from "../../apiManager/ApiCall";
import { subscriptionCancellationSurveysURL } from "apiManager/APIConfig";

const base = subscriptionCancellationSurveysURL;

/** Admin: GET /api/payment/subscription/cancellation-surveys */
export const GetSubscriptionCancellationSurveysCall = async ({
  limit = 50,
  offset = 0,
} = {}) => {
  try {
    const q = new URLSearchParams();
    q.set("limit", String(limit));
    q.set("offset", String(offset));
    const response = await CallAPI({
      url: `${base}?${q.toString()}`,
      method: "GET",
    });
    if (response?.success && Array.isArray(response?.data)) {
      return {
        rows: response.data,
        total: typeof response.total === "number" ? response.total : response.data.length,
      };
    }
    return { rows: [], total: 0 };
  } catch {
    return { rows: [], total: 0 };
  }
};

/** Admin: DELETE /api/payment/subscription/cancellation-surveys/:id */
export const DeleteSubscriptionCancellationSurveyCall = async (id) => {
  try {
    const response = await CallAPI({
      url: `${base}/${encodeURIComponent(id)}`,
      method: "DELETE",
    });
    return { ok: response?.success === true, response };
  } catch {
    return { ok: false, response: null };
  }
};

/** Admin: POST /api/payment/subscription/cancellation-surveys/bulk-delete */
export const BulkDeleteSubscriptionCancellationSurveysCall = async (ids) => {
  try {
    const response = await CallAPI({
      url: `${base}/bulk-delete`,
      method: "POST",
      body: { ids },
    });
    return {
      ok: response?.success === true,
      deleted: typeof response?.deleted === "number" ? response.deleted : 0,
      response,
    };
  } catch {
    return { ok: false, deleted: 0, response: null };
  }
};
